import { connect } from 'react-redux'
import { compose, mapProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import { applyFilter, resetFilters } from '../actions'
import BrandBreadcrumbs from './BrandBreadcrumbs'

const withTransformRefinementCrumbs = mapProps(({ refinementCrumbs, ...props }) => ({
  ...props,
  refinementCrumbs: refinementCrumbs.map(({ removeAction: { navigationState } = {}, ...crumbProps } = {}) => ({
    ...crumbProps,
    navigationState
  }))
}))

export default compose(
  withType({ type: 'BrandBreadcrumbs' }),
  connect(null, { applyFilter, resetFilters }),
  withTransformRefinementCrumbs
)(BrandBreadcrumbs)
